import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Modules
import { RoutingModule } from './routing.module';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Components
import { AppComponent } from './app.component';
import { provideNgxMask } from 'ngx-mask';
const maskConfig = {
  validation: false,
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    // angular
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    //
    RoutingModule,
    SharedModule,
    CoreModule,
    // 3rd party modules
    NgxPermissionsModule.forRoot(),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    // Angular 21+ defaults to zoneless; restore Zone-based CD for existing HTTP/subscribe patterns
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideNgxMask(maskConfig),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
